"use client";

import * as React from "react";
import { format } from "date-fns";
// import { format } from "date-fns";
import { ro } from "date-fns/locale";

import { cn } from "../lib/utils";
import { Calendar } from "./ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "./ui/popover";

export default function DatePicker({ className, selectedDate, handleDateChange, fromDate,
  toDate, disabled }) {
  const [date, setDate] = React.useState(selectedDate);
  const [dis, setDis] = React.useState(disabled);
  // import { format } from "date-fns";

const handleChange = (newDate) => {
  if (!newDate) return;
  setDate(newDate);

  const formattedDate = format(newDate, "yyyy-MM-dd");

  handleDateChange({ target: { value: formattedDate } });
};


  return (
    <div className={cn("grid gap-2", className)}>
      <Popover>
        <PopoverTrigger asChild>
          <button
            id="date"
            className={cn(
              "btn px-2.5 min-w-[15.5rem] h-[3rem] bg-white border-gray-500 hover:border-gray-300 dark:border-gray-200/60 dark:hover:border-gray-500 dark:bg-gray-800 text-gray-600 hover:text-gray-800 dark:text-gray-300 dark:hover:text-gray-100 font-medium text-left justify-start",
              !date && "text-muted-foreground"
            )}
          >
            <svg className="fill-current text-gray-400 dark:text-gray-500 ml-1 mr-2" width="16" height="16" viewBox="0 0 16 16">
              <path d="M5 4a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2H5Z"></path>
              <path d="M4 0a4 4 0 0 0-4 4v8a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4H4ZM2 4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4Z"></path>
            </svg>
            {/* {date ? format(date, "dd LLL y") : <span>Selecteaza o data</span>} */}
            {date
              ? format(date, "dd MMMM yyyy", { locale: ro }).replace(/^\d+\s(\w)/, (match, p1) =>
                match.replace(p1, p1.toUpperCase()))
              : <span>Selectează o dată</span>}
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar
            mode="single"
            locale={ro}
            defaultMonth={date}
            selected={date}
            onSelect={handleChange}
            fromDate={fromDate} // data minimă
            toDate={toDate}     // data maximă
            disabled={(date) =>
              (fromDate && date < fromDate) || (toDate && date > toDate) || dis
            }
          />
        </PopoverContent>
      </Popover>
    </div>
  );
}